// components/ProductCard.tsx
import { Download, Calculator } from 'lucide-react';

type ProductCardProps = {
  title: string;
  description: string;
  features: string[];
  imageSrc?: string;
  imageAlt?: string;
  notice: string;
  downloadFile: string;
  onDownloadIFU: () => void;
  onRequestQuote: () => void;
};

export const ProductCard = ({
  title,
  description,
  features,
  imageSrc,
  imageAlt = '',
  notice,
  downloadFile,
  onDownloadIFU,
  onRequestQuote,
}: ProductCardProps) => {
  return (
    <div className="relative overflow-visible bg-white rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100">
      {/* รูปสินค้า */}
      {imageSrc && (
        <div
          // มือถือ: static | >=sm: absolute (ลอย)
          className="static sm:absolute sm:inset-x-0 sm:-top-6 md:-top-8 z-10 flex justify-center sm:pointer-events-none"
        >
          <img
            src={imageSrc}
            alt={imageAlt}
            // base: 80% ของการ์ด | >=sm: ขยายตาม breakpoint
            className="w-[80%] h-auto sm:w-48 md:w-56 lg:w-64 object-contain drop-shadow-xl"
          />
        </div>
      )}

      {/* เนื้อหาในการ์ด */}
      <div className="pt-6 sm:pt-24 md:pt-32 px-6 pb-6">
        <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
        <p className="mt-2 text-gray-600 min-h-[64px]">{description}</p>

        <ul className="mt-4 space-y-2">
          {features.map((f, i) => (
            <li key={i} className="flex items-start gap-2">
              <span className="mt-1 inline-block w-2 h-2 rounded-full bg-emerald-500 flex-shrink-0" />
              <span className="text-gray-700">{f}</span>
            </li>
          ))}
          {notice && (
            <li className="flex items-start gap-2">
              <span className="mt-1 inline-block w-2 h-2 rounded-full bg-emerald-500 flex-shrink-0" />
              <span className="text-red-700">{notice}</span>
            </li>)}
        </ul>

        <div className="mt-6 space-y-3">
          <a
            href={downloadFile} target="_blank"
            className="w-full border border-primary text-primary hover:bg-primary hover:text-white rounded-lg px-4 py-2.5 font-medium transition-colors flex items-center justify-center gap-2"
          >
            {/* ... */}
            Download IFU (PDF)
          </a>
          <button
            onClick={onRequestQuote}
            className="w-full bg-primary hover:bg-primary/90 text-white rounded-lg px-4 py-2.5 font-semibold transition-colors flex items-center justify-center gap-2"
          >
            {/* ... */}
            Request Quote
          </button>
        </div>
      </div>
    </div>
  );
};
